import React, { useEffect, useState } from "react";
import Card from "../../../src/components/card/Card";
import AddCategory from "./admin/AddCategory";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  AddCategoryData,
  UpdateCategoryData,
  GetCategoryListAsync,
  GetCategoryList,
} from "../../features/learning/CategorySlice";

const LearningNew = () => {
  const dispatch = useAppDispatch();

  const addData = useAppSelector(AddCategoryData);
  const updateData = useAppSelector(UpdateCategoryData);
  const categoryList = useAppSelector(GetCategoryList);

  const [dataList, setDataList] = useState<any>([]);

  useEffect(() => {
    dispatch(GetCategoryListAsync());
  }, [addData, updateData]);

  useEffect(() => {
    if (categoryList?.length > 0) {
      let list: any = [];
      categoryList?.map((val: any) => {
        let obj = {
          id: val?.id,
          title: val?.categoryName,
          description: val?.categoryDescription,
          externalUrl: `/learning/${val?.id}`,
          openURLSameWindow: true,
        };
        list = [...list, obj];
      });
      setDataList([...list]);
    }
  }, [categoryList]);

  return (
    <>
      <Card
        type={1}
        title={"Resources"}
        modal={<AddCategory />}
        data={dataList}
        modalLink="View"
        fetchLearningModuleData={""}
        sliceData={false}
      />
    </>
  );
};

export default LearningNew;
